import { render } from "./NoDataFoundBanner.vue?vue&type=template&id=2f0fe600&scoped=true"
const script = {}

import "./NoDataFoundBanner.vue?vue&type=style&index=0&id=2f0fe600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0fe600"]])

export default __exports__